// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 753 ? "logins" : chunkId) + "." + {"191":"316d50e8","753":"2d64d636"}[chunkId] + ".css";
};